<mat-form-field appearance="outline" *ngIf="timeArray.length > 0" class="w-100">
  <mat-label>{{ placeholder }}</mat-label>
  <mat-select [value]="selectedTime" (valueChange)="onSelect($event)" [required]="required">
    <mat-option *ngFor="let time of timeArray" [value]="time.actualValue">
      {{ time.actualValue | timeToDate | localizedDate:'shortTime' }}
    </mat-option>
  </mat-select>
</mat-form-field>